export const CARRIER_BASEURL = '/tms/Dispatcher';
export const FLEETMANAGER_BASEURL = '/tms/Dispatcher';
export const CUSTOMER_BASEURL = '/loads';